<template>
  <div>
    <div class="grid grid-cols-1 hidden">
      <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
      <select
        aria-label="Select a tab"
        class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
      >
        <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
      </select>
      <ChevronDownIcon
        class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
        aria-hidden="true"
      />
    </div>
    <div class="block">
      <div :class="{ 'border-b border-gray-200': showBorder }">
        <nav class="-mb-px flex space-x-2" aria-label="Tabs">
          <a
            v-for="tab in tabs"
            @click.prevent="$emit('selected', tab)"
            :key="tab.name"
            :href="tab.href"
            :class="[
              tab.current
                ? 'border-cyan-500 text-pdsPrimaryColor bg-stone-100 rounded-t-lg'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
              'group inline-flex items-center border-b-2 px-3 py-2 text-base font-bold cursor-pointer relative'
            ]"
            :aria-current="tab.current ? 'page' : undefined"
          >
            <component
              :is="tab.icon"
              :class="[
                tab.current ? 'text-pdsPrimaryColor' : 'text-gray-400 group-hover:text-gray-500',
                '-ml-0.5 mr-2 size-5'
              ]"
              aria-hidden="true"
            />
            <span>{{ tab.name }}</span>
            <span
              class="ml-2 rounded-full text-white px-2 py-0.5 text-xs flex items-center justify-center min-w-[1.5rem] bg-pdsPrimaryColor"
              v-if="tab.count !== undefined && tab.count !== null && tab.count > 0"
            >
              {{ tab.count }}
            </span>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ChevronDownIcon } from '@heroicons/vue/16/solid';
const props = defineProps({
  tabs: {
    type: Array,
    required: true
  },
  showBorder: {
    type: Boolean,
    default: true
  }
});
</script>
